{
  "PHONE_CTRLS": {
    "EXTENSION_BANNER": {
      "TEXT": "لم يتم تثبيت امتداد Chrome.",
      "CTA": "تثبيت الامتداد"
    },
    "CONNECTION_ERROR": {
      "TITLE": "تعذّر الاتصال بنظام الهاتف",
      "MESSAGE": "يبدو أن اتصال الإنترنت لديك مقطوع. يُرجى التحقق منه والمحاولة مرة أخرى.",
      "CREDENTIALS_TITLE": "رفض نظام الهاتف بيانات اعتمادك",
      "CREDENTIALS_MESSAGE": "رفض نظام الهاتف اسم المستخدم أو كلمة المرور المحفوظين في ملفك الشخصي. تحقق منهما في إعدادات الملف الشخصي، أو تواصل مع مسؤول النظام.",
      "CONFIGURATION_TITLE": "إعدادات الهاتف غير صالحة",
      "CONFIGURATION_MESSAGE": "اسم مستخدم SIP أو عنوان الخادم ليس بتنسيق صالح، لذا يتعذر على الهاتف الاتصال. أصلح ذلك في إعدادات الملف الشخصي.",
      "NETWORK_SHORT": "فشل الاتصال",
      "CREDENTIALS_SHORT": "تم رفض بيانات الاعتماد",
      "CONFIGURATION_SHORT": "إعدادات هاتف غير صالحة",
      "RETRY": "إعادة المحاولة",
      "DISMISS": "إلغاء"
    },
    "CONNECTION_QUALITY": "جودة الاتصال",
    "CONNECTION_QUALITY_EXCELLENT": "ممتازة",
    "CONNECTION_QUALITY_GOOD": "جيدة",
    "CONNECTION_QUALITY_FAIR": "متوسطة",
    "CONNECTION_QUALITY_POOR": "ضعيفة",
    "CONNECTION_QUALITY_DISCONNECTED": "منقطعة",
    "TABS": {
      "PHONE": "الهاتف",
      "SMS": "SMS",
      "HISTORY": "السجل"
    },
    "HISTORY": {
      "OPEN": "فتح",
      "RECENT": "الأخيرة",
      "MISSED": "الفائتة",
      "LOADING": "جاري تحميل المكالمات...",
      "EMPTY": "لا توجد مكالمات هنا",
      "ERROR": "تعذّر تحميل المكالمات",
      "CALL": "معاودة الاتصال",
      "CALL_STATUS": {
        "BUTTON": "تعيين حالة المكالمة",
        "TITLE": "حالة المكالمة",
        "SEARCH_PLACEHOLDER": "البحث عن الحالات...",
        "LOADING": "جاري تحميل الحالات...",
        "NO_OPTIONS": "لا توجد حالات مكالمات مُعدّة",
        "NO_MATCH": "لا توجد حالة مطابقة",
        "OPTIONS_ERROR": "تعذّر تحميل الحالات",
        "RETRY": "إعادة المحاولة",
        "CONFIRM_QUESTION": "تعيين «{status}» وحل المحادثة؟",
        "CONFIRM": "تأكيد",
        "BACK": "العودة",
        "CANCEL": "إلغاء",
        "SAVING": "جاري الحفظ...",
        "SAVE_ERROR": "تعذّر حفظ الحالة",
        "RESOLVE_ERROR": "تم حفظ الحالة، ولكن تعذّر حل المحادثة"
      }
    },
    "SMS": {
      "NUMBER_PLACEHOLDER": "رقم الهاتف، مثل +421903000000",
      "BODY_PLACEHOLDER": "اكتب رسالتك...",
      "SEGMENTS": "({segments} SMS)",
      "SEND": "إرسال SMS",
      "SENDING": "جارٍ الإرسال...",
      "SENT": "تم إرسال الرسالة",
      "LOADING": "جارٍ تحميل قنوات SMS...",
      "NO_INBOX": "لا تحتوي هذه المنصة على قناة SMS، لذا لا يمكن إرسال الرسالة.",
      "INVALID_NUMBER": "أدخل الرقم بالصيغة الدولية، بما في ذلك علامة + في البداية.",
      "ERROR": "تعذر إرسال الرسالة. يرجى المحاولة مرة أخرى."
    },
    "ACTIONS": {
      "CONNECT": "اتصال",
      "GO_TO_TAB": "الانتقال إلى علامة التبويب تلك",
      "DISCONNECT": "قطع الاتصال",
      "ANSWER": "الرد",
      "HANGUP": "إنهاء المكالمة",
      "HOLD": "تعليق المكالمة",
      "MUTE": "كتم الميكروفون",
      "SILENCE": "كتم الصوت",
      "TRANSFER": "تحويل",
      "COMPLETE_TRANSFER": "إكمال التحويل",
      "RETURN_TO_CALLER": "العودة إلى المتصل",
      "CANCEL_TRANSFER": "إلغاء التحويل",
      "DIALPAD": "إظهار لوحة الاتصال",
      "OPEN_CONVERSATION": "فتح المحادثة"
    },
    "NOTIFICATIONS": {
      "INCOMING_CALL": "مكالمة واردة",
      "INCOMING_CALL_FROM": "مكالمة واردة من {name} ({number})",
      "INCOMING_CALL_FROM_NUMBER": "مكالمة واردة من {number}",
      "ANSWER": "الرد",
      "DECLINE": "رفض"
    },
    "TRANSFER": {
      "TITLE": "تحويل المكالمة",
      "PLACEHOLDER": "أدخل رقم وجهة التحويل...",
      "SEARCH_PLACEHOLDER": "البحث عن الموظفين...",
      "TARGET_PLACEHOLDER": "وجهة التحويل المحددة",
      "CONFIRM": "تحويل",
      "MODE_DIRECT": "التحويل الآن",
      "MODE_CONSULT": "الاتصال بالموظف أولاً",
      "CANCEL": "إلغاء"
    },
    "QUEUE_BREAK": {
      "CONFIRM_BREAK": "هل أنت متأكد أنك تريد أخذ استراحة في جميع قوائم الانتظار؟",
      "CONFIRM_READY": "هل أنت متأكد أنك تريد العودة إلى حالة الجاهزية في جميع قوائم الانتظار؟",
      "CONFIRM_BREAK_QUEUE": "هل أنت متأكد أنك تريد تسجيل الخروج من قائمة الانتظار {queue}؟",
      "CONFIRM_READY_QUEUE": "هل أنت متأكد أنك تريد تسجيل الدخول إلى قائمة الانتظار {queue}؟",
      "LOGIN_TO_QUEUE": "تسجيل الدخول",
      "LOGOUT_FROM_QUEUE": "تسجيل الخروج",
      "LOGIN_TO_ALL_QUEUES": "تسجيل الدخول إلى جميع قوائم الانتظار",
      "LOGOUT_FROM_ALL_QUEUES": "تسجيل الخروج من جميع قوائم الانتظار",
      "OPTION_LOGOUT": "تسجيل الخروج",
      "OPTION_BREAK": "استراحة",
      "OPTION_LUNCH": "غداء",
      "OPTION_AWAY": "غير متواجد",
      "OPTION_DO_NOT_DISTURB": "عدم الإزعاج",
      "OPTION_BUSINESS_TRIP": "رحلة عمل",
      "CONFIRM": "تأكيد",
      "CANCEL": "إلغاء"
    },
    "STATUS": {
      "OFFLINE": "الهاتف غير متصل",
      "IN_OTHER_TAB": "الهاتف متصل في علامة تبويب أخرى",
      "CONNECTING": "جاري الاتصال...",
      "DISCONNECTING": "جاري قطع الاتصال...",
      "ONLINE": "الهاتف متصل",
      "DIALING": "جارٍ الطلب",
      "TRANSFERRING": "جاري التحويل...",
      "CONSULTING": "جارٍ التحدث مع الموظف",
      "CALLER_ON_HOLD": "المتصل قيد الانتظار",
      "BUSY": "مشغول",
      "DND": "DND",
      "UNAVAILABLE": "غير متاح",
      "REJECTED": "تم رفض المكالمة",
      "CALL_FAILED": "فشلت المكالمة"
    },
    "QUEUES": {
      "MORE": "قوائم انتظار أخرى"
    }
  },
  "DIAL_REDIRECT": {
    "DIALING": "جارٍ الاتصال بالرقم {number}… يمكنك إغلاق علامة التبويب هذه.",
    "NO_NUMBER": "لم يتم تقديم أي رقم. استخدم ?number=+420..."
  },
  "PHONE_DIAL": {
    "PLACEHOLDER": "أدخل رقم الهاتف...",
    "ACTIONS": {
      "DIAL": "طلب الرقم",
      "DIAL_FROM": "اختر الرقم الذي تتصل منه"
    },
    "DIAL_FROM": {
      "TITLE": "الاتصال من رقم صندوق الوارد"
    },
    "VALIDATION": {
      "REQUIRED": "رقم الهاتف مطلوب",
      "INVALID_FORMAT": "تنسيق رقم الهاتف غير صالح"
    }
  },
  "PHONE_AUDIO": {
    "TITLE": "إعدادات الصوت والاختبار",
    "SELECT_DEVICE": "اختر جهازًا...",
    "SYSTEM_DEFAULT": "افتراضي النظام",
    "SAVED": "تم الحفظ",
    "DISCONNECTED_SUFFIX": "غير متصل",
    "DEVICE_DISCONNECTED": "الجهاز المحدد غير متصل. ستستخدم المكالمات الجهاز الافتراضي للنظام حتى يعود الاتصال.",
    "MICROPHONE": {
      "TITLE": "الميكروفون",
      "START_TEST": "اختبار الميكروفون",
      "STOP_TEST": "إيقاف الاختبار",
      "LEVEL": "المستوى:",
      "VERDICT": {
        "LISTENING": "قل شيئًا في الميكروفون…",
        "SILENT": "لا يمكن سماع صوتك. تحقق من أن الميكروفون يعمل وأن الجهاز الصحيح محدد.",
        "LOW": "يمكن سماع صوتك بصوت منخفض فقط. اختر ميكروفونًا آخر أو اضبط مستوى الإدخال في إعدادات النظام.",
        "GOOD": "صوت جيد — يمكن سماعك بوضوح."
      }
    },
    "SPEAKER": {
      "TITLE": "مكبر الصوت",
      "TEST": "اختبار مكبر الصوت",
      "TESTING": "جارٍ الاختبار...",
      "VOLUME": "مستوى الصوت:",
      "USING_DEFAULT": "المخرج المحدد غير متاح — تم التشغيل عبر الجهاز الافتراضي للنظام."
    },
    "DONE": "تم",
    "ERRORS": {
      "MICROPHONE_ACCESS": "حدث خطأ أثناء الوصول إلى الميكروفون. يرجى التحقق من الأذونات.",
      "MICROPHONE_PERMISSION_DENIED": "الوصول إلى الميكروفون محظور. اسمح به من إعدادات الموقع في متصفحك لاستخدام الهاتف.",
      "MICROPHONE_SILENT": "لا يلتقط الميكروفون أي صوت. تحقق من إعدادات الصوت.",
      "EXTENSION_REQUIRED": "لم يتم العثور على امتداد الهاتف. يرجى تثبيته أو تفعيله لاستخدام الميكروفون.",
      "SPEAKER_TEST": "حدث خطأ أثناء اختبار مخرج مكبر الصوت."
    }
  },
  "PHONE_STATUS": {
    "OFFLINE": "غير متصل",
    "ONLINE": "متصل",
    "BUSY": "مشغول"
  },
  "QUEUE_STATUS": {
    "READY": "جاهز",
    "NOT_READY": "لا يقبل المكالمات",
    "WRAP_UP": "المعالجة اللاحقة",
    "BREAK": "استراحة",
    "LUNCH": "غداء",
    "AWAY": "غير متواجد",
    "DO_NOT_DISTURB": "عدم الإزعاج",
    "BUSINESS_TRIP": "رحلة عمل",
    "OTHER_CALL": "مكالمة أخرى",
    "QUEUE_CALL": "مكالمة قائمة الانتظار",
    "OFFLINE": "غير متصل",
    "ONLINE": "متصل",
    "NO_ACCESS": "لا يوجد هاتف",
    "PARTIALLY_READY": "جاهز جزئيًا",
    "MIXED": "مختلط",
    "CHAT_ONLINE": "متصل (محادثة)",
    "CHAT_BUSY": "مشغول (محادثة)",
    "CHAT_OFFLINE": "غير متصل (محادثة)"
  }
}
